// extracted by mini-css-extract-plugin
export var container = "_58-0";
export var fallback = "_58-5";
export var fallbackIcon = "_58-6";
export var hidden = "_58-2";
export var image = "_58-3";
export var loaded = "_58-4";
export var placeholder = "_58-1";